// removed by extract-text-webpack-plugin
module.exports = {"elevatorsScoreSettings":"_2q2k-vOH0X-jzo6Y7F6Ub7","column":"NYFVuQ9CYP48Xc6XSH1EK","menuButton":"_10NntwDPFPzovIrLoJF8Qm","active":"_2Seeb8jtkVh-4iFmKPNx99","cropPlanCultures":"_1YHt9ERcRE0AvRq6z4ltpp","cropPlanCulture":"j7-LyYHKd_xDpdVhEx6-s","cultureCircle":"_1mBDmiP7F0_B0iBtGTyHhW","wheat":"_3M866_FS1E16NNoFcoKFMA","culture":"_2bvh4YS6YzKnsxCJNgC5","rape":"_3eqDkcDeg9GIK_azu-MEnw","soy":"ljCAZ7AgRCo3ePghgdN1a","sunflower":"OY8dLXlNrH8zsMprMu9nj","corn":"_1oVWoU3nSvd9A-eC_rBJKn","cropPlanAdjust":"_1UBUkEHu5cooc6mlMOUgLf"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/containers/Results/index.css
// module id = 220
// module chunks = 0